import React, { useState, useEffect } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SegmentedControl } from 'segmented-control'; 
import downloadpng from "../../images/download.png";
import printpng from "../../images/print.png"
import Collapsible from 'react-collapsible';
import Common from '../../Common/CommonAPI';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader";
import plus from "../../images/plus.png";
import minus from "../../images/minus.png";

function Savingsdetails (props) {   

const [valueofseg,setSegmentValue] = useState("one");
const [Sdate,setSdate] = useState(new Date().setMonth(new Date().getMonth()+(-1)));
const [Edate,setEdate] = useState(new Date());
const [AccountDetailList,setAccountDetailList] = useState([]);
const [pendingTransactionList,setpendingTransactionList] = useState([]);
const [pendingChequeList,setpendingChequeList] = useState([]);
const [EndBalance,setEndBalance] = useState();
const [StartBalance,setStartBalance] = useState();
const [InterestAmount,setInterestAmount] = useState(0);
const [RateSlabVal,setRateSlabVal] = useState();
const [Originl,setOriginl] = useState();
const [Destination,setDestination] = useState();
const [AvailableBalance,setAvailableBalance] = useState();
const [DateRangeSubmit,setDateRangeSubmit] = useState(false);
const [printPDF,setprintPDF] = useState();
const [Loading,setLoading] = useState(true);
const [openPDF,setopenPDF] = useState(false);
          



    useEffect( () => {   
    DateRange();
    },[]);

    const DateRange = ()=> {
        setLoading(true);
        Common.SavingsDescriptionAPI(
        {
            AccID: SavAccID.savAccDetails.id,
            Sdate:Sdate,
            Edate:Edate,
        },(result)=>{
            console.log(result.data);
            setAccountDetailList(result.data.accountStatement.accountTransactionList?result.data.accountStatement.accountTransactionList.reverse():null);
            setpendingTransactionList(result.data.accountStatement.pendingTransactionList?result.data.accountStatement.pendingTransactionList.reverse():null);
            setpendingChequeList(result.data.accountStatement.pendingchequeList?result.data.accountStatement.pendingchequeList.reverse():null);
            setEndBalance(result.data.accountStatement.accountTransactionList[result.data.accountStatement.accountTransactionList.length-1]);
            setStartBalance(result.data.accountStatement.accountTransactionList[0]);
            setInterestAmount(result.data.interestAmount);
            setRateSlabVal(result.data.rateSlab?result.data.rateSlab:null);
            setOriginl(result.data.rateSlab?result.data.rateSlab.shift():null);
            setDestination(result.data.rateSlab?result.data.rateSlab.pop():null);
            setAvailableBalance( result.data.accountStatement.availableBalance);
            setDateRangeSubmit(false);
            setprintPDF(result.data.accountStatement.accStatement);
            setLoading(false);

    });
}
const ResponseLoadingModal =() =>{
    return(
        <Modal
        size="lg"
        centered 
        className="ui-block" show={Loading}>          
              <FadeLoader
              height={25}
              width={5}
              radius={2}
              margin={2}
              color={"#197b55"}
              size={"80px"} this also works
              loading={Loading}
            />       
       </Modal>
     )
  }

  const PrintDocumentModal =() =>{
    return(
        <Modal
        size="lg"
        centered 
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        show={openPDF} 
        onHide={()=>setopenPDF(!setopenPDF)}
        >
        <Modal.Header closeButton>
            <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                <p className='modal-head-f'>ACCOUNT </p><br/>STATEMENT
            </Modal.Title>
        </Modal.Header>
            <Modal.Body>               
                <iframe className="print-div4"
                    src={"data:application/pdf;base64,"+printPDF}>
                </iframe>         
            </Modal.Body>  
       </Modal>
     )
  }
var arry  = AccountDetailList.map(( listValue, index ) => {return (listValue.moneyIn)})
var TotalMoneyIn = arry.reduce((acc,val)=>{
                        return acc+val;
                    },0)

var arry2  = AccountDetailList.map(( listValue, index ) => {return (listValue.moneyOut)})
var TotalMoneyOut = arry2.reduce((acc,val)=>{
                        return acc+val;
                        },0)

var arry3  = pendingTransactionList.map(( listValue, index ) => {return (listValue.moneyOut)})
var TotalPendingMoneyOut = arry3.reduce((acc,val)=>{
                                return acc+val;
                            },0)
var FixStartBalance = EndBalance?(EndBalance.balance+ (EndBalance.moneyIn?-EndBalance.moneyIn:EndBalance.moneyOut)):"0.00"
  
var SavAccID = JSON.parse(sessionStorage.getItem("SavingsValue"));
var SavingAccountDetails = SavAccID.savAccDetails;
var jointHolders = SavingAccountDetails.savingsCustomerList.filter(e=>e.joinHolder==1);

return (

            <div>
                 {ResponseLoadingModal()}
                 {PrintDocumentModal()}
                <Row>
                    <p className='p-line2'>SAVINGS ACCOUNT INFORMATION</p>
                </Row>
                <Row  className='block'>                    
                    <Col lg={8} >                        
                        <div className='savbox-bground d-flex flex-row justify-content-center'>
                            <DatePicker
                            className="savDe-d-picker"
                            selected={Sdate}
                            onChange={(date) => setSdate(date)}
                            placeholderText="Start Date" />

                            <DatePicker
                            className="savDe-d-picker"
                            selected={Edate}
                            onChange={(date) => setEdate(date)}
                            placeholderText="End Date" />                            
                            <Button variant="success" onClick={()=>DateRange()}>SUBMIT</Button>
                            </div> 
                            <Row>
                                <Col sm={7}>
                                <SegmentedControl
                                name="oneDisabled" 
                                setValue={e => setSegmentValue(e)}                               
                                options={[
                                    { label: "TRANSACTIONS" , value: "one", default: true },
                                    { label: "PENDING TRANSACTION /HOLD", value: "two" },
                                    { label: "UNREALIZED CHEQUES", value: "three" },
                                ]}
                                className="segment"
                                /> 
                                </Col>
                                <Col sm={4} xs={10}>
                                <div className='d-flex  block-top flex-row justify-content-end'>
                                    <p className='t-width rmv-pad3 text-color' >Account No</p>
                                    <p className='p-box4'>{SavAccID.savAccDetails.accountNo}</p>                                    
                                </div>
                                </Col>
                                <Col sm={1} xs={1}>
                                  <img className='downlogo ms-top' onClick={()=>setopenPDF(true)}src={downloadpng} alt="download" />
                                </Col> 
                            </Row> 
                            {valueofseg==="one"? 
                               <div className="tableFixHead block">                    
                                <Table   hover responsive size="sm">
                                        <thead >
                                            <tr className='tr-h' >
                                                <th className='td-width1'>Date</th>
                                                <th className='td-width1 t-left'>Description</th>
                                                <th className='td-width1 t-right'>Amount</th>
                                                <th className='td-width1 t-right'>Available Balance </th>                                            
                                            </tr>
                                        </thead>
                                        
                                        <tbody className='scroll2' >                                        
                                            { AccountDetailList.length>0?AccountDetailList.map(( listValue, index ) => {  
                                        return (
                                        <tr  className='tr-h t-font-c'>
                                            <td className='td-width1'>
                                                <p className='m-bottom t-left'>{listValue.transactionTypeName=="Interest"?moment(listValue.transactionDate).format('DD/MM/YYYY'):moment(listValue.transactionDateTime).format('DD/MM/YYYY - hh:mm:ss a')}</p>
                                            </td>                                    
                                            <td className='td-width1'>
                                                <p className='m-bottom t-left'>{listValue.transactionTypeName=="Bank Charge"&&listValue.moneyOut===0.0?"Bank Charge Reversals":listValue.transactionTypeName} {listValue.billProvider?" - "+listValue.billProvider:""} {listValue.transactionLoc?" - "+listValue.transactionLoc:""}</p>
                                            </td>                              
                                            {listValue.moneyIn===0.0?
                                            <td className='td-width1'>
                                            <div className='d-flex flex-row align-items-center justify-content-end'>
                                                <p className="moneyout-p m-bottom ">
                                                {listValue.moneyOut.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </p>
                                                <img className="moneyIn-out m-bottom" src={minus} alt="banner"/>
                                            </div>
                                            </td>
                                            :<td className='td-width1'>
                                                <div className='d-flex flex-row align-items-center justify-content-end'>
                                                    <p className="moneyin-p m-bottom">
                                                    {listValue.moneyIn.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                    </p>
                                                    <img className="moneyIn-out m-bottom" src={plus} alt="banner"/>
                                                </div>                                     
                                            </td>
                                            }                                       
                                            <td  className='td-width1'>
                                                <p className='m-bottom t-right'>{listValue.balance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                            </td>
                                        </tr>);
                                        }):
                                        <tr  className='tr-h'>
                                            <td colspan="4"><p className='t-center block-top'>No Records</p></td>
                                        </tr> 
                                        }
                                    </tbody>
                                </Table>                               
                                </div>        
                             
                            :valueofseg==="two"?
                            <div className="tableFixHead block">
                                <Table   hover responsive size="sm">
                                    <thead >
                                        <tr className='tr-h' >
                                            <th className='td-width1 t-left'>Date</th>
                                            <th className='td-width1 t-left'>Description</th>
                                            <th className='td-width1 t-right'>Amount</th>
                                            <th className='td-width t-right'>Available Balance </th>                                            
                                        </tr>
                                    </thead>
                                        <tbody className='scroll2'>
                                        {(pendingTransactionList.length>0)?pendingTransactionList.map(( listValue, index ) => { 
                                return(
                                    <tr  className='tr-h'>
                                    <td className='td-width1 t-left'>
                                        <p className='m-bottom'>{moment(listValue.transactionDate).format('DD/MM/YYYY')}</p>                                        
                                    </td>
                                    <td className='td-width1 t-left'>
                                        <p className='m-bottom'>{listValue.transactionTypeName} {listValue.billProvider?" - "+listValue.billProvider:""} {listValue.transactionLoc?" - "+listValue.transactionLoc:""}</p>
                                     </td>
                                                                          
                                        {listValue.moneyIn===0.0?
                                        <td className='td-width1 t-right'> 
                                            <p className="moneyout-p m-bottom">
                                            {listValue.moneyOut.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </p>                                        
                                        </td>
                                        :
                                        <td className='td-width1 t-right'>
                                            <p className="moneyin-p m-bottom">
                                            {listValue.moneyIn.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                            </p>                                     
                                        </td>
                                        }                                         
                                    
                                    <td className='td-width t-right'>
                                        <p className='m-bottom'>{listValue.balance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    </td>
                                </tr>
                                )
                                 }):
                                 <tr  className='tr-h'>
                                  <td colspan="4"><p className='t-center block-top'>No Records</p></td>
                                </tr>  
                                }
                                </tbody>
                                </Table>                              
                            </div>:
                            valueofseg==="three"?
                            <div className="tableFixHead block">
                                <Table   hover responsive size="sm">
                                    <thead >
                                        <tr className='tr-h' >
                                            <th className='td-width t-left'>Cheque No</th>
                                            <th className='td-width t-left'>Cheque Date</th>
                                            <th className='td-width t-left'>Created Date</th>
                                            <th className='td-width t-right'>Transaction Reference</th>                                            
                                            <th className='td-width t-right'>Amount LKR</th>                                            
                                        </tr>
                                    </thead>
                                        <tbody className='scroll2'>
                                        {(pendingChequeList.length>0)?pendingChequeList.map(( listValue, index ) => {
                                return (
                                    <tr  className='tr-h'>
                                    <td className='td-width2 t-left'>
                                        <p className='m-bottom'>{listValue.chequeNo}</p>                                            
                                    </td>
                                    <td className='td-width2 t-left'>
                                        <p className='m-bottom'>{listValue.chequeDate?moment(listValue.chequeDate).format('DD/MM/YYYY'):"-"}</p>
                                    </td>
                                    <td className='td-width2 t-left'>
                                        <p className='m-bottom'>{listValue.createdDate?moment(listValue.createdDate).format('DD/MM/YYYY'):"-"}</p>
                                    </td>
                                    <td className='td-width2 t-right'>
                                        <p className='m-bottom'>{listValue.bank} {listValue.branch?" - "+listValue.branch:""}</p>
                                    </td>                                     
                                    {listValue.amount?
                                    <td className='td-width2 t-right'>
                                    <p className='m-bottom'>
                                        {listValue.amount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </p>
                                    </td>
                                    :null
                                    }  
                                </tr>
                                ) 
                                })
                                :
                                <tr  className='tr-h'>
                                  <td colspan="5"><p className='t-center block-top'>No Records</p></td>
                                </tr>                              
                                }
                                </tbody>
                            </Table>
                                                                
                            </div>
                            :null}    
                   </Col>
                    <Col lg={4} >
                        <div className='div-background2'>
                        <Accordion defaultActiveKey="0" flush>
                            <Accordion.Item  eventKey="0">
                                <Accordion.Header>ACCOUNT SUMMARY</Accordion.Header>
                                <Accordion.Body className='ts-size' >
                                <div className='d-flex t-bold flex-row justify-content-between'>
                                    <p className=' text-color'>Start Balance</p>
                                    <p className='text-color'>LKR {EndBalance?FixStartBalance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):null}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Money In</p>
                                    <p className='text-color'>LKR {(TotalMoneyIn-InterestAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='moneyout-p'>Money Out</p>
                                    <p className='moneyout-p'>LKR {TotalMoneyOut.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Pending Transactions/ Holds</p>
                                    <p className='text-color'>LKR {TotalPendingMoneyOut.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Interest</p>
                                    <p className='text-color'>LKR {InterestAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </div>
                                <div className='d-flex t-bold flex-row justify-content-between'>
                                    <p className=' text-color'>End Balance</p>
                                    <p className='text-color'>LKR {AvailableBalance?AvailableBalance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):null}</p>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>INTEREST RATES</Accordion.Header>
                                <Accordion.Body className='ts-size'>
                                <div className='d-flex t-bold flex-row justify-content-between'>
                                    <p className=' text-color'></p>
                                    <p className='text-color'>Interest</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Less than LKR {Originl?Originl.description.split("/",2)[1]:null}</p>
                                    <p className='text-color'>{Originl?Originl.rate.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):null}%</p>
                                </div>
                                
                                {RateSlabVal?RateSlabVal.map((ListVal,index)=>{
                                var firstval = ListVal?ListVal.description.split("/"):null;
                                return(
                                    <div className='d-flex flex-row justify-content-between'>
                                        <p className='text-color'> {firstval[0]} - LKR {firstval[1]}</p>
                                        <p className='text-color'>{ListVal.rate.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</p>
                                    </div>                                    
                                  )
                                }):null
                                }
                                
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className=' text-color'>LKR {Destination?Destination.description.split("/",1):null} and above</p>
                                    <p className='text-color'>{Destination?Destination.rate.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):null}%</p>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>ACCOUNT DETAILS</Accordion.Header>
                                <Accordion.Body className='ts-size'>
                                <div className='d-flex t-bold flex-row justify-content-between'>
                                    <p className=' text-color'>Main Holder Name</p>
                                    <p className='text-color t-right'>{SavingAccountDetails.mainHolderName}</p>
                                </div>
                                {jointHolders.length>0?jointHolders.map((listValue,index)=>{

                                return (
                                <div  className='d-flex flex-row justify-content-between'>
                                <p className=' text-color'> Joint Holder Name {index+1} </p>
                                <p className='text-color t-right'>
                                    : {listValue.customerID.title} {listValue.customerID.firstName} {listValue.customerID.lastName}
                                </p>
                                </div>);
                                })
                                :null
                                }
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Account Number</p>
                                    <p className='text-color'>{SavingAccountDetails.accountNo}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Open Date</p>
                                    <p className='text-color'>{moment(SavingAccountDetails.openDate).format("DD/MM/YYYY")}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Maximum Widthdraw Limit</p>
                                    <p className='text-color'>Rs. {SavingAccountDetails.maxWitLimit.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Branch</p>
                                    <p className='text-color'>{SavingAccountDetails.location}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className=' text-color'>Savings Account Type</p>
                                    <p className='text-color'>{SavingAccountDetails.accTypeName}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className=' text-color'>Account Mode</p>
                                    <p className='text-color'>{SavingAccountDetails.accountMode}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className=' text-color'>Account Operated by</p>
                                    <p className='text-color'> {SavingAccountDetails.fromOrToAccount==1?SavingAccountDetails.actOptBy:SavingAccountDetails.mainHolderName}</p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className=' text-color'>Account Status</p>
                                    <p className='text-color'>
                                    {SavingAccountDetails.status=="ACT"?"Active":SavingAccountDetails.status=="DOR"?"Dormant"
                                    :SavingAccountDetails.status=="INA"?"Inactive":SavingAccountDetails.status=="SUS"?"Suspend"
                                    :SavingAccountDetails.status=="FOR"?"Force Closure":SavingAccountDetails.status=="VOL"?"Voluntarily Closure"
                                    :SavingAccountDetails.status=="INI"?"Initiate":null
                                    }
                                    </p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className=' text-color'>ATM Status</p>
                                    <p className='text-color'>
                                    {SavingAccountDetails.atmStatus=="ACT"?" Active":SavingAccountDetails.atmStatus=="INI"?" Initiate"
                                    :SavingAccountDetails.atmStatus=="PEN"?" Pending":SavingAccountDetails.atmStatus=="INA"?" Inactive"
                                    :SavingAccountDetails.atmStatus=="REJ"?" Rejected":null}
                                    </p>
                                </div>
                                <div className='d-flex flex-row justify-content-between'>
                                    <p className='text-color'>Savings Currency</p>
                                    <p className='text-color'>{SavingAccountDetails.savingAccountType.savingsCurrency.currencyName}</p>
                                </div>
                                <div className='d-flex t-left flex-row justify-content-between'>
                                    <p className='text-color'>Permanent Address</p>
                                    <p className='t-right text-color'>
                                        {SavingAccountDetails.savingsCustomerList.map((listValue,index)=>{
                                        return(listValue.mainHolder==1?
                                            <p  className="sav-detailbox-row3" style={{fontSize:9}}>
                                            : {listValue.customerID.permenentAddress.addressLine1}
                                            <br/> {listValue.customerID.permenentAddress.addressLine2} {listValue.customerID.permenentAddress.locality}
                                            </p>:
                                            null)
                                        })
                                        }
                                    </p>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        </div>
                   </Col>
                   
                </Row>
                
            </div>
          );
    }

export default Savingsdetails;